import { useState, useRef } from "react";
import "./editorialForms.css";

export default function MoviePortalForm({ data, onChange }) {
  const [castInput, setCastInput] = useState("");
  const posterInputRef = useRef(null);
  const videoInputRef = useRef(null);

  const handlePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        onChange({
          ...data,
          posterImage: file,
          posterImageName: file.name,
          posterImagePreview: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange({ ...data, videoFile: file, videoFileName: file.name });
    }
  };

  const genres = [
    "Acao",
    "Aventura",
    "Animacao",
    "Comedia",
    "Crime",
    "Documentario",
    "Drama",
    "Familia",
    "Fantasia",
    "Terror",
    "Romance",
    "Ficcao Cientifica",
    "Suspense",
    "Guerra",
    "Faroeste",
  ];

  const handleAddCast = () => {
    if (castInput.trim()) {
      const currentCast = data?.cast || [];
      onChange({
        ...data,
        cast: [...currentCast, { name: castInput.trim(), character: "" }],
      });
      setCastInput("");
    }
  };

  const handleRemoveCast = (index) => {
    const currentCast = data?.cast || [];
    onChange({
      ...data,
      cast: currentCast.filter((_, i) => i !== index),
    });
  };

  const handleCastCharacter = (index, character) => {
    const currentCast = [...(data?.cast || [])];
    currentCast[index] = { ...currentCast[index], character };
    onChange({ ...data, cast: currentCast });
  };

  const handleGenreToggle = (genre) => {
    const currentGenres = data?.genre || [];
    if (currentGenres.includes(genre)) {
      onChange({
        ...data,
        genre: currentGenres.filter((g) => g !== genre),
      });
    } else {
      onChange({
        ...data,
        genre: [...currentGenres, genre],
      });
    }
  };

  return (
    <div className="editorial_form movie_portal_form">
      <div className="editorial_form_section">
        <label>
          Poster <span className="required">*</span>
        </label>
        <div className="file_upload_area" onClick={() => posterInputRef.current?.click()}>
          <input
            ref={posterInputRef}
            type="file"
            accept="image/*,.jpg,.jpeg,.png,.webp"
            onChange={handlePosterChange}
            style={{ display: "none" }}
          />
          {data?.posterImagePreview ? (
            <div className="file_selected sticker_preview">
              <img src={data.posterImagePreview} alt="Poster" style={{ maxWidth: "120px", maxHeight: "200px", borderRadius: "8px" }} />
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, posterImage: null, posterImageName: null, posterImagePreview: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
              </svg>
              <p>Clique para fazer upload do poster</p>
              <span>JPG, PNG, WEBP</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Vídeo Trailer (opcional)</label>
        <div className="file_upload_area" onClick={() => videoInputRef.current?.click()}>
          <input
            ref={videoInputRef}
            type="file"
            accept="video/*,.mp4,.mov,.avi,.mkv,.webm"
            onChange={handleVideoChange}
            style={{ display: "none" }}
          />
          {data?.videoFileName ? (
            <div className="file_selected">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
              </svg>
              <span>{data.videoFileName}</span>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange({ ...data, videoFile: null, videoFileName: null });
                }}
                className="file_remove_btn"
              >
                ✕
              </button>
            </div>
          ) : (
            <div className="file_placeholder">
              <svg viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
                <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
              </svg>
              <p>Clique para fazer upload do trailer</p>
              <span>MP4, MOV, AVI, MKV, WEBM</span>
            </div>
          )}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Titulo <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Titulo do filme/serie"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Titulo Original</label>
        <input
          type="text"
          placeholder="Titulo original (se diferente)"
          value={data?.originalTitle || ""}
          onChange={(e) => onChange({ ...data, originalTitle: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Sinopse</label>
        <textarea
          placeholder="Descreva o filme ou serie..."
          value={data?.synopsis || ""}
          onChange={(e) => onChange({ ...data, synopsis: e.target.value })}
          maxLength={2000}
          rows={4}
        />
      </div>

      <div className="editorial_form_section">
        <label>Generos</label>
        <div className="genre_chips">
          {genres.map((genre) => (
            <span
              key={genre}
              className={`genre_chip ${
                (data?.genre || []).includes(genre) ? "selected" : ""
              }`}
              onClick={() => handleGenreToggle(genre)}
            >
              {genre}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Data de Lancamento</label>
          <input
            type="date"
            value={data?.releaseDate || ""}
            onChange={(e) => onChange({ ...data, releaseDate: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Duracao (min)</label>
          <input
            type="number"
            placeholder="120"
            value={data?.runtime || ""}
            onChange={(e) =>
              onChange({ ...data, runtime: parseInt(e.target.value) || 0 })
            }
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Diretor</label>
          <input
            type="text"
            placeholder="Nome do diretor"
            value={data?.director || ""}
            onChange={(e) => onChange({ ...data, director: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Idioma</label>
          <select
            value={data?.language || "pt"}
            onChange={(e) => onChange({ ...data, language: e.target.value })}
          >
            <option value="pt">Portugues</option>
            <option value="en">Ingles</option>
            <option value="es">Espanhol</option>
            <option value="fr">Frances</option>
            <option value="de">Alemao</option>
            <option value="it">Italiano</option>
            <option value="ja">Japones</option>
            <option value="ko">Coreano</option>
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Elenco
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddCast}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Nome do ator/atriz"
          value={castInput}
          onChange={(e) => setCastInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddCast()}
        />
        {(data?.cast || []).map((member, i) => (
          <div key={i} className="variant_row">
            <input type="text" value={member.name} disabled />
            <input
              type="text"
              placeholder="Personagem"
              value={member.character || ""}
              onChange={(e) => handleCastCharacter(i, e.target.value)}
            />
            <button
              type="button"
              className="remove_variant_btn"
              onClick={() => handleRemoveCast(i)}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Avaliacao (0-10)</label>
          <input
            type="number"
            min="0"
            max="10"
            step="0.1"
            placeholder="8.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
          />
        </div>

        <div className="editorial_form_section">
          <label>Pais</label>
          <input
            type="text"
            placeholder="Brasil"
            value={data?.country || ""}
            onChange={(e) => onChange({ ...data, country: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Link do Trailer (YouTube)</label>
        <input
          type="url"
          placeholder="https://youtube.com/watch?v=..."
          value={data?.trailer || ""}
          onChange={(e) => onChange({ ...data, trailer: e.target.value })}
        />
      </div>

      <div className="editorial_form_tip movie_portal_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z" />
        </svg>
        <span>
          Adicione filmes ou series ao portal de cinema. Inclua informacoes
          detalhadas para melhor descoberta.
        </span>
      </div>
    </div>
  );
}
